import { render, staticRenderFns } from "./Parution.vue?vue&type=template&id=39a9a2ca&scoped=true&"
import script from "./Parution.vue?vue&type=script&lang=js&"
export * from "./Parution.vue?vue&type=script&lang=js&"
import style0 from "./Parution.vue?vue&type=style&index=0&id=39a9a2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a9a2ca",
  null
  
)

export default component.exports